// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3Yh7u","info":"PatientInfo_info__3FKZg"};